import { Component, HostBinding, computed } from '@angular/core';
import { AddressLabelComponent } from '../../address-label.component';

@Component({
  selector: 'zipcode',
  standalone: true,
  template: `
    <span class="pdd-lt-xs">מיקוד</span>
    <span>{{ zipCode$$() }}</span>
  `
})
export class ZipCodeComponent extends AddressLabelComponent {
  @HostBinding('class.zipcode-label')
  zipCode$$ = computed<string>(() => this.addressFormat$$()?.zipCode);
}
